import {
  CourseTopicState,
  CourseTopicActionTypes,
  COURSE_TOPICS_REQUEST,
  COURSE_TOPICS_SUCCESS,
  COURSE_TOPICS_FAILURE,
} from "./types";

/**
 * Initial state for the course topic reducer.
 */
const initialState: CourseTopicState = {
  courseTopics: [],
  isLoading: false,
  courseTopicsLoaded: false,
  error: false,
};

/**
 * Reducer handling course topic state changes.
 *
 * Manages course topic data, loading state, and error state
 * based on dispatched actions.
 *
 * @param state - Current course topic state.
 * @param action - Action dispatched to update the state.
 * @returns Updated state after applying the action.
 */
export const courseTopicReducer = (
  state = initialState,
  action: CourseTopicActionTypes
): CourseTopicState => {
  switch (action.type) {
    case COURSE_TOPICS_REQUEST:
      return { ...state, isLoading: true, courseTopicsLoaded: false, error: false };
    case COURSE_TOPICS_SUCCESS:
      return {
        ...state,
        courseTopics: action.data,
        isLoading: false,
        courseTopicsLoaded: true,
        error: false,
      };
    case COURSE_TOPICS_FAILURE:
      return { ...state, isLoading: false, courseTopicsLoaded: true, error: true };
    default:
      return state;
  }
};
